/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  ConHomeWebControllerV1HomeIndustryDataInfoUsingGet1Params,
  ResultConHomeBrandInfoResponse,
  ResultConHomeHotCityResponse,
  ResultConHomeHotFinanceResponse,
  ResultConHomeIndustryDataResponse,
  ResultConHomeIndustryHeaderListResponse,
  ResultConHomeNewBrandCityDataResponse,
  ResultConHomeNewBrandResponse,
} from './data-contracts';
import { HttpClient, RequestParams } from './http-client';

export class ConHomeWebController<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags con-home-web-controller
   * @name ConHomeWebControllerV1HomeBrandInfoUsingGet1
   * @summary 查询首页品牌数据信息
   * @request GET:/consumebrand/web/v1/home/brandinfo
   * @secure
   */
  conHomeWebControllerV1HomeBrandInfoUsingGet1 = (params: RequestParams = {}) =>
    this.request<ResultConHomeBrandInfoResponse, void>({
      path: `/consumebrand/web/v1/home/brandinfo`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags con-home-web-controller
   * @name ConHomeWebControllerV1HomeHotCityDataUsingGet1
   * @summary 查询首页热门城市数据信息
   * @request GET:/consumebrand/web/v1/home/hotcitydata
   * @secure
   */
  conHomeWebControllerV1HomeHotCityDataUsingGet1 = (params: RequestParams = {}) =>
    this.request<ResultConHomeHotCityResponse, void>({
      path: `/consumebrand/web/v1/home/hotcitydata`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags con-home-web-controller
   * @name ConHomeWebControllerV1HomeHotFinanceUsingGet1
   * @summary 查询首页热门投资机构信息
   * @request GET:/consumebrand/web/v1/home/hotfinance
   * @secure
   */
  conHomeWebControllerV1HomeHotFinanceUsingGet1 = (params: RequestParams = {}) =>
    this.request<ResultConHomeHotFinanceResponse, void>({
      path: `/consumebrand/web/v1/home/hotfinance`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags con-home-web-controller
   * @name ConHomeWebControllerV1HomeIndustryDataInfoUsingGet1
   * @summary 查询首页行业数据信息
   * @request GET:/consumebrand/web/v1/home/industrydatainfo/{industryTrackId}
   * @secure
   */
  conHomeWebControllerV1HomeIndustryDataInfoUsingGet1 = (
    { industryTrackId, ...query }: ConHomeWebControllerV1HomeIndustryDataInfoUsingGet1Params,
    params: RequestParams = {}
  ) =>
    this.request<ResultConHomeIndustryDataResponse, void>({
      path: `/consumebrand/web/v1/home/industrydatainfo/${industryTrackId}`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags con-home-web-controller
   * @name ConHomeWebControllerV1HomeIndustryHeaderListUsingGet1
   * @summary 查询首页行业展示信息列表
   * @request GET:/consumebrand/web/v1/home/industryheaderlist
   * @secure
   */
  conHomeWebControllerV1HomeIndustryHeaderListUsingGet1 = (params: RequestParams = {}) =>
    this.request<ResultConHomeIndustryHeaderListResponse, void>({
      path: `/consumebrand/web/v1/home/industryheaderlist`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags con-home-web-controller
   * @name ConHomeWebControllerV1HomeNewBrandDataUsingGet1
   * @summary 查询首页最新品牌数据信息(除地域分布数据外)
   * @request GET:/consumebrand/web/v1/home/mewbranddata
   * @secure
   */
  conHomeWebControllerV1HomeNewBrandDataUsingGet1 = (params: RequestParams = {}) =>
    this.request<ResultConHomeNewBrandResponse, void>({
      path: `/consumebrand/web/v1/home/mewbranddata`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags con-home-web-controller
   * @name ConHomeWebControllerV1HomeNewBrandCityDataUsingGet1
   * @summary 查询首页最新品牌地域分布数据信息
   * @request GET:/consumebrand/web/v1/home/newbrandcitydata
   * @secure
   */
  conHomeWebControllerV1HomeNewBrandCityDataUsingGet1 = (params: RequestParams = {}) =>
    this.request<ResultConHomeNewBrandCityDataResponse, void>({
      path: `/consumebrand/web/v1/home/newbrandcitydata`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
}
